import { Component, ElementRef, EventEmitter, Input, Output, Pipe, PipeTransform, QueryList, ViewChildren } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AgGridEvent, GridApi, GridReadyEvent, RowNode, SelectionChangedEvent } from 'ag-grid-community';
import { observable, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ActionCoAffaire, ActionCoBoModel, ActionCoCardModel, ActionCoContact, ActionCoDevisModel, ActionCoTransformData, ActionCoTransformModel, BObjectModel, BreadcrumbModel, BreadDik, Corporation, CountLigneDevisTransform, CustomgridColumnDefs, CustomgridModel, CustomgridSQL, LigneDevisFooterTranform, LigneDevisTransform, ModeTransformation, QResult, QueovalItem, QueovalParam, StageInter, StageState, TypeLigneDevis } from '../../../models';
import { HttpService, CoreService, BreadcrumbService, } from '../../../services';
import { ToastService } from '../../../toast';
import { ActionCoService } from '../action-co-services/action-co.service';

@Pipe({
  name: 'selectionStageTitle'
})
export class SelectionStageTitlePipe implements PipeTransform {

  constructor() { }

  transform(ListStageInter: StageInter[], ListResa: string[]): string {
    const lignesSelectionnees: string[] = [];
    if (ListStageInter)
      for (let i: number = 0; i < ListStageInter.length; i++) {
        if (ListResa.includes(ListStageInter[i].IdResa)) {
          lignesSelectionnees.push(ListStageInter[i].Value);
        }
      }
    return lignesSelectionnees.join(' \n');
  }
}


@Component({
  selector: 'q-action-co-transform',
  templateUrl: './action-co-transform.component.html',
  styleUrls: ['./action-co-transform.component.css', '../action-co-devis/action-co-devis.component.css',]
})

export class ActionCoTransformComponent {

  constructor(
    protected http: HttpService,
    protected indParam: CoreService,
    protected toast: ToastService,
    protected actionCoService: ActionCoService,
    protected modalService: NgbModal,
    private breadCrumb: BreadcrumbService,
  ) { }

  Model: ActionCoTransformModel = new ActionCoTransformModel();
  Footer: LigneDevisFooterTranform = new LigneDevisFooterTranform();
  TransformBtnLabel: string;
  TransformBtnShow: boolean = true;
  public IdContact: string;
  public IdContactPrincipal: string;
  public selectParcoursDevis: string;
  public ModeTransform: string;

  public enumModeTransformation = ModeTransformation;
  public enumStageState = StageState;
  public enumTypeLigneDevis = TypeLigneDevis;

  public ShowBtnCreate: boolean = false;

  public ShowTab: boolean = false;
  public Active = 1;
  public ListBo: Array<any> = new Array<any>();
  public isReloading: boolean = true;

  public DisableBntCnt: boolean = false;

  public GridConfigStageInter: CustomgridModel;
  public IsReloadingGird: boolean = true;
  public GridFirstCheck: boolean = true;
  public ModalLigne: LigneDevisTransform;
  public LigneLoading: boolean = true;
  public modeBo: string = '';
  public mainContact: boolean = false;

  @Input() set idDevis(value: string) {
    if (value) {
      this.Model.Devis.Ident = value;
    }
  }

  @Output() setIdActionCo: EventEmitter<string> = new EventEmitter<string>();

  @ViewChildren("LigneDevis") LigneDevis: QueryList<ElementRef>;


  public transformBtn: Array<{ Title: string; Value: ModeTransformation; Nb: number }> = [
    { Title: 'Convention', Value: ModeTransformation.CONVENTION, Nb: 0, },
    { Title: 'Affaire', Value: ModeTransformation.AFFAIRE, Nb: 0, },
    { Title: 'Prestation', Value: ModeTransformation.PRESTATION, Nb: 0, },
  ]

  public ngOnInit(): void {
    if (this.actionCoService.Model.idActionCo) {
      this.Model.ActionCo.Ident = this.actionCoService.Model.idActionCo;
    }

    // Chargement actionco projet devis lignes
    const actionCoDevisModel: ActionCoDevisModel = new ActionCoDevisModel();
    //actionCoDevisModel.Mode = 'INITDEVIS';
    actionCoDevisModel.ActionCo.Ident = this.Model.ActionCo.Ident;
    actionCoDevisModel.Devis.Ident = this.Model.Devis.Ident;
    this.actionCoService.GetInfoDevis(actionCoDevisModel).subscribe((data: ActionCoDevisModel) => {
      // this.http.postHttp<ActionCoDevisModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Devis`, actionCoDevisModel).subscribe((data: ActionCoDevisModel) => {
      if (!data.HasError) {
        this.Model.Devis = data.Devis;
        this.Model.ActionCo = data.ActionCo;
        this.Model.Project = data.Project;
        this.Model.ListContact = data.ListContact;
        this.Model.ListContactPrincipal = data.ListContactPrincipal;
        this.Model.PersonneMorale = JSON.parse(JSON.stringify(data.PersonneMorale));
        this.Model.Financeur = JSON.parse(JSON.stringify(data.PersonneMorale));


        this.Model.DataTransformation = Array<ActionCoTransformData>();
        this.transformBtn.forEach(tab => {
          let data: ActionCoTransformData = new ActionCoTransformData();
          data.ModeTransform = tab.Value;
          this.Model.DataTransformation.push(data);
        })

        this.Model.Mode = "GETALLLIGNEDEVIS";

        this.GetLigneDevis().subscribe((data: ActionCoTransformModel) => {

          let defaultOnglet: number = 0;
          let defaultOngletBool: boolean = false;
          for (let i: number = 0; i < data.DataTransformation.length; i++) {
            if (data.DataTransformation[i].LigneDevis.length > 0) {
              defaultOnglet = defaultOngletBool ? defaultOnglet : i;
              defaultOngletBool = true;
            }
          }
          this.ChangeOngletTransformation(this.transformBtn[defaultOnglet]);
          this.LigneLoading = false;
        });
      }
    });


  }

  public ChangeOngletTransformation(transform: { Title: string; Value: ModeTransformation }) {

    this.Model.ModeTransform = transform.Value;
    this.ShowTab = false;
    if (this.Model.DataLigneDevis) {
      const idOdlData: number = this.Model.DataTransformation.findIndex((d: ActionCoTransformData) => { return d.ModeTransform == this.Model.DataLigneDevis.ModeTransform })
      this.Model.DataTransformation[idOdlData] = this.Model.DataLigneDevis;
    }

    const idNewData: number = this.Model.DataTransformation.findIndex((d: ActionCoTransformData) => { return d.ModeTransform == transform.Value });
    this.Model.DataLigneDevis = this.Model.DataTransformation[idNewData];


    if (this.Model.DataLigneDevis?.LigneDevis && transform.Value != ModeTransformation.CONVENTION) {
      this.Model.DataLigneDevis.LigneDevis.forEach((ldv: LigneDevisTransform) => { ldv.Selected = false; });
    }


    this.TransformBtnShow = true;
    switch (transform.Value) {
      case ModeTransformation.CONVENTION:
        this.TransformBtnShow = this.Model.DataLigneDevis.LigneDevis.some((ligne: LigneDevisTransform) => !ligne.Locked);
        this.DisableBntCnt = (this.Model.DataLigneDevis.Convention && this.Model.DataLigneDevis.Convention.id) ? true : false;
        this.TransformBtnLabel = this.DisableBntCnt ? "Modifier la convention" : "Créer la convention";
        break;
      case ModeTransformation.AFFAIRE:
        this.TransformBtnLabel = "Créer l'affaire";
        break;
      case ModeTransformation.PRESTATION:
        this.TransformBtnLabel = "Créer la prestation";
        break;
    }

    if (!this.Model.DataLigneDevis.IsDirty) {
      this.ManageStateChange();
      this.ModeTransform = transform.Title;
    } else {
      this.GetLigneDevis().subscribe((data: ActionCoTransformModel) => {
        this.Model.DataLigneDevis = this.Model.DataTransformation[idNewData]
        this.ManageStateChange();
        this.ModeTransform = transform.Title;
      });
    }
    if (transform.Value == ModeTransformation.CONVENTION && this.Model?.DataLigneDevis?.Convention?.id && this.Model?.DataLigneDevis?.Convention?.id != '0') {
      this.GetContactByConvention();
      this.GetFinanceurByConvention();
    }
  };
  public Transform() {
    this.Model.Mode = 'TRANSFORM';
    if (this.Model.DataLigneDevis.LigneDevis.some((ligne: LigneDevisTransform) => ligne.Selected)) {

      if (this.CheckStageInterState()) {
        return;
      }

      const idOdlData: number = this.Model.DataTransformation.findIndex((d: ActionCoTransformData) => { return d.ModeTransform == this.Model.DataLigneDevis.ModeTransform })
      this.Model.DataTransformation[idOdlData] = this.Model.DataLigneDevis;

      this.indParam.showSplash(true);
      this.http.postHttp<ActionCoTransformModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Transform/`, this.Model).subscribe((data: ActionCoTransformModel) => {
        if (!data.HasError) {
          this.Model = data;
          let selectedLigne = this.Model.DataLigneDevis.LigneDevis.find((Ligne: LigneDevisTransform) => { return Ligne.Selected });
          this.ManageStateChange(selectedLigne);

          switch (this.Model.ModeTransform) {
            case ModeTransformation.CONVENTION:
              this.TransformBtnLabel = "Modifier la convention";
              break;
            case ModeTransformation.PRESTATION:
              this.InitRadioAffaire(selectedLigne);
              break;
          }
          this.TransformBtnShow = this.Model.DataLigneDevis.LigneDevis.some((ligne: LigneDevisTransform) => !ligne.Locked);

          this.indParam.showSplash(false);
        }
      });
    } else {
      this.toast.showWarningToast("Aucune ligne sélectionnée");
    }
  }

  public SelectCheckLigne(pLigne: LigneDevisTransform) {
    pLigne.Selected = pLigne.Selected ? false : true;
    this.CalcFooter();
  }
  public SelectRadioAffairePrestation(pLigne: LigneDevisTransform) {
    if (!pLigne.Selected) {
      this.Model.DataLigneDevis.LigneDevis.forEach((ligne: LigneDevisTransform) => {
        ligne.Selected = false;
      });
      pLigne.Selected = true;
      this.DisableBntCnt = pLigne.Locked;
      if (pLigne.Locked && (pLigne.IdAffa != '0' || pLigne.IdPrestation != '0')) {
        this.ShowBtnCreate = false;
        this.OpenBo(pLigne);
      } else {
        this.ShowBtnCreate = true;
        this.ShowTab = false;
      }

      if (this.Model.ModeTransform == ModeTransformation.PRESTATION) {
        this.InitRadioAffaire(pLigne);
      } else if (this.Model.ModeTransform == ModeTransformation.AFFAIRE) {
        this.InitListCntAffaire(pLigne);
      }
    }
    this.CalcFooter();
  }

  private CalcNbOnglet() {
    this.transformBtn.forEach((onglet: { Title: string; Value: ModeTransformation; Nb: number }) => {
      switch (onglet.Value) {
        case ModeTransformation.CONVENTION:
          onglet.Nb = this.GetNbLigneDevis('CONVENTION');
          break;
        case ModeTransformation.AFFAIRE:
          onglet.Nb = this.GetNbLigneDevis('AFFAIRE');
          break;
        case ModeTransformation.PRESTATION:
          onglet.Nb = this.GetNbLigneDevis('PRESTATION');
          break;
      }
    });
  }
  private GetNbLigneDevis(segmentation: string): number {
    let l = this.Model.CountLigneDevisTransforms.find((x: CountLigneDevisTransform) => { return x.LigneLabel == segmentation })
    return l ? l.Count : 0;
  }

  private CalcFooter() {
    this.Footer = new LigneDevisFooterTranform();
    this.Model.DataLigneDevis.LigneDevis.forEach((ligne: LigneDevisTransform) => {
      if (ligne.Selected || ligne.Locked) {
        this.Footer.HT += ligne.MontantHT
        this.Footer.Remise += ligne.MontantRemiseHT;
        this.Footer.TTC += ligne.MontantTTC;
        this.Footer.TVA += ligne.MontantTVA;
      }
    });
  }

  public GetContact(selected: QueovalItem, type: string) {
    switch (type) {
      case 'Contact':
        this.IdContact = selected.Value;
        break;
      case 'ContactPrincipal':
        this.IdContactPrincipal = selected.Value;
        break;
    }
  }
  public AddCnt(element: ActionCoContact) {
    element.selected = true;
  }
  public RemoveCnt(element: ActionCoContact) {
    element.selected = false;
  }
  public CheckListCnt(ListContact: Array<any>, selected: boolean = true): boolean {
    return selected ? ListContact?.some(cnt => cnt.selected) : ListContact?.some(cnt => !cnt.selected);
  }
  public OnChangeFinanceur(strCustomer: QueovalItem): void {
    if (strCustomer.Value != 'DELETE') {
      this.Model.Financeur.SocialReason = strCustomer.Text;
      this.Model.Financeur.Id = strCustomer.Value;
    }
  }

  private ManageStateChange(pLigne: LigneDevisTransform | null = null) {
    this.isReloading = true;
    this.ListBo = new Array<any>();
    this.Active = 1;
    this.ShowTab = false;
    this.ShowBtnCreate = false;
    this.DisableBntCnt = false;
    switch (this.Model.ModeTransform) {
      case ModeTransformation.CONVENTION:
        this.ShowBtnCreate = true;
        this.ShowTab = (this.Model.DataLigneDevis.Convention && this.Model.DataLigneDevis.Convention.id) ? true : false;
        this.DisableBntCnt = this.ShowTab;
        let firstLigne: any = this.Model.DataLigneDevis.LigneDevis.find((ligne: LigneDevisTransform) => { return ligne.Selected && ligne.TypeLigne != TypeLigneDevis.FRAIS && ligne.IdStage });
        this.GetBo('REL_BO_STAGE_BO_CVT', firstLigne?.IdStage, this.Model.DataLigneDevis.Convention.id).subscribe((resultBo: BObjectModel) => {
          let bo: any = { Title: 'Convention', Model: resultBo, IdFils: this.Model.DataLigneDevis.Convention.id }
          this.ListBo.push(bo);
        });
        break;

      case ModeTransformation.AFFAIRE:
        if (pLigne) {
          this.ShowTab = pLigne.IdAffa != '0' ? true : false;
          this.OpenBo(pLigne);
        }
        break;
      case ModeTransformation.PRESTATION:
        if (pLigne) {
          this.ShowTab = pLigne.IdPrestation != '0' ? true : false;
          this.OpenBo(pLigne);
        }
        break;
    }
    this.CalcFooter();
  }

  public clotureActionCo(): void {

    const model: ActionCoDevisModel = new ActionCoDevisModel();
    model.Mode = 'CLOTURE_ACTIONCO';
    model.ActionCo = this.Model.ActionCo;
    this.http.postHttp<ActionCoDevisModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Devis`, model).subscribe(
      (result: ActionCoDevisModel) => {
        if (!result.HasError) {
          // Maj de l'etat de l'action commerciale : Clôturé(e) valeur 3 ou En cours valeur 1
          this.actionCoService.Model.IsCloture = this.Model.ActionCo.IsCloture;
          this.setIdActionCo.emit(this.Model.ActionCo.Ident);
        }
      });

  }

  public OpenPersonneMorale(): void {
    //Changement de contexte vers la personne morale
    this.modalService.dismissAll();
    this.breadCrumb.loadContextSegmentation(this.Model.PersonneMorale.IsClient ? 'BO_CSOC' : 'BO_CPPT', this.Model.PersonneMorale.Id, null, true);
  }

  public OpenStage(ligne: LigneDevisTransform) {
    //Redirection vers le stage sur l'onglet convention
    const param: QueovalParam = new QueovalParam(new BreadDik('idConvention', this.Model.DataLigneDevis.Convention.id));
    this.modalService.dismissAll();
    this.breadCrumb.call(new BreadcrumbModel('add', `view/formations/stage-detail/${ligne.IdStage}/convention/`, param, 'Stage', false));
  }

  public OpenBo(ligne: LigneDevisTransform) {
    switch (this.Model.ModeTransform) {
      case ModeTransformation.CONVENTION:
        this.GetBo('REL_BO_CENT_BO_STAGE', '1348', ligne.IdStage).subscribe((resultBo: BObjectModel) => {
          let bo: any = { Title: 'Stage', Model: resultBo, IdFils: ligne.IdStage }
          if (this.ListBo.length > 1) {
            this.ListBo[1] = bo;
          } else {
            this.ListBo.push(bo);
          }
          this.Active = 2;
        });
        break;
      case ModeTransformation.AFFAIRE:
        this.ShowTab = ligne.IdAffa != '0' ? true : false;
        this.GetBo('REL_BO_CSOC_BO_AFFA', this.Model.PersonneMorale.Id, ligne.IdAffa).subscribe((resultBo: BObjectModel) => {
          let bo: any = { Title: 'Affaire', Model: resultBo, IdFils: ligne.IdAffa }
          this.ListBo = [bo];
          this.Active = 1;
        });
        break;
      case ModeTransformation.PRESTATION:
        this.ShowTab = ligne.IdPrestation != '0' ? true : false;
        this.GetBo('REL_BO_CSOC_BO_PRESTATION', this.Model.PersonneMorale.Id, ligne.IdPrestation).subscribe((resultBo: BObjectModel) => {
          let bo: any = { Title: 'Prestation', Model: resultBo, IdFils: ligne.IdPrestation }
          this.ListBo = [bo];
          this.Active = 1;
        });
        break;
    }
  }

  public OnOpenBo(type: string, mainContact: boolean = false) {
    this.mainContact = mainContact;
    this.modeBo = type;
  }

  public OnCloseBo(value: QueovalItem) {
    if (this.modeBo === 'CONTACT') {
      if (this.Model.ModeTransform == ModeTransformation.CONVENTION && this.Model?.DataLigneDevis?.Convention?.id && this.Model?.DataLigneDevis?.Convention?.id != '0') {
        this.GetContactByConvention(value);
      }
      else {
        const model: ActionCoDevisModel = new ActionCoDevisModel();
        model.Mode = 'CONTACTS';
        model.PersonneMorale = this.Model.PersonneMorale;
        model.Devis = this.Model.Devis;
        this.http.postHttp<ActionCoDevisModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Devis`, model).subscribe(
          (result: ActionCoDevisModel) => {
            if (!result.HasError) {
              if (value != null) {
                const newContact: ActionCoContact | undefined = result.ListContact.find(cnt => cnt.id == value.Value);
                const newResp: ActionCoContact | undefined = result.ListContactPrincipal.find(cnt => cnt.id == value.Value);
                if (newContact) {
                  if (!newResp || !this.mainContact) {
                    newContact.selected = true;
                  }
                  this.Model.ListContact.push(newContact);
                }
                if (newResp) {
                  newResp.selected = this.mainContact;
                  this.Model.ListContactPrincipal.push(newResp);
                }
              }
            }
          });
      }
    }
    this.modeBo = '';
  }

  private GetBo(rel: string, idPere: string, idFils: string): Observable<BObjectModel> {
    return this.http.getHttp<ActionCoBoModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Bo/GET_BO/0|${rel}|${idPere}|${idFils}/`).pipe(
      mergeMap((result: ActionCoBoModel) => {
        const BoResult = new BObjectModel();
        BoResult.IdDonneeFils = result.BusinessObject.IdDonneeFils;
        BoResult.IdDonneePere = result.BusinessObject.IdDonneePere;
        BoResult.IdentBO = result.BusinessObject.IdentBo;
        BoResult.IdRelation = result.BusinessObject.IdRelation;
        BoResult.ShowSaveButton = true;
        this.isReloading = false;
        return of(BoResult);
      })
    )
  }
  private GetLigneDevis(): Observable<ActionCoTransformModel> {
    this.Model.Mode = "GETALLLIGNEDEVIS";
    return this.http.postHttp<ActionCoTransformModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Transform`, this.Model).pipe(
      mergeMap((data: ActionCoTransformModel) => {
        this.Model = data;
        this.CalcNbOnglet();
        return of(data)
      })
    )
  }

  public handleRadioAffaire(affaire: ActionCoAffaire) {
    this.Model.DataLigneDevis.Affaires.forEach((affa) => {
      affa.Selected = false;
    });
    affaire.Selected = true;
  }
  public InitRadioAffaire(pLigne: LigneDevisTransform | undefined) {
    if (pLigne) {
      this.Model.DataLigneDevis.PrestaAffaireLock = false;
      this.Model.DataLigneDevis.Affaires.forEach((affa: ActionCoAffaire) => {
        affa.Selected = false;
        if (affa.id == pLigne.IdAffa) {
          affa.Selected = true;
          this.Model.DataLigneDevis.PrestaAffaireLock = true;
        }
      });
    }
  }
  public InitListCntAffaire(pLigne: LigneDevisTransform) {
    if (pLigne.Locked) {
      this.http.getHttp<ActionCoTransformModel>(`${this.indParam.AppParams.apiUrl}api/ActionCO/Transform/GETCNTBYAFFA/${pLigne.IdAffa}/`).subscribe((result: ActionCoTransformModel) => {
        if (!result.HasError) {
          this.Model.ListContact.forEach((cnt: ActionCoContact) => {
            cnt.selected = result.ListCntAffa.includes(cnt.id);
          });
          this.Model.ListContactPrincipal.forEach((cnt: ActionCoContact) => {
            cnt.selected = result.ListCntAffa.includes(cnt.id);
          });
        }
      });
    }

  }

  public openModal(content: any, ligne: LigneDevisTransform) {
    this.IsReloadingGird = true;
    this.GridConfigStageInter = new CustomgridModel();
    this.http.getHttp<CustomgridModel>(`${this.indParam.AppParams.apiUrl}api/customgrid/getData/STRUCTURE/selectParcoursDevis/`).subscribe((data: CustomgridModel) => {

      data.GridXml.rowData.data = JSON.stringify(ligne.ListStageInter);
      data.cgParameters.isDataLoaded = true;
      this.GridConfigStageInter = data;
      this.ModalLigne = ligne;
      this.IsReloadingGird = false;
      this.modalService.open(content, { size: 'q-xxl', windowClass: 'qmodalover', centered: true });
    });
  }

  public closeModal(modal: NgbActiveModal) {
    modal.close();
  }


  public OnGridReady(event: GridReadyEvent, ligne: LigneDevisTransform) {
    this.GridFirstCheck = true;
    event.api.forEachLeafNode((node: RowNode) => {
      if (node.data.IdStage == ligne.IdStage && (ligne.ListResa && ligne.ListResa.length > 0 && ligne.ListResa.find(resa => resa == node.data.IdResa) != undefined)) {
        node.setSelected(true);
        setTimeout(() => { this.GridFirstCheck = false; }, 0);
      }
    });
    setTimeout(() => { this.GridFirstCheck = false; }, 0);
  }
  public OnModalStageInterChange(event: SelectionChangedEvent, modal: NgbActiveModal) {
    if (!this.GridFirstCheck) {

      this.ModalLigne.ListResa = new Array<string>();

      // Liste des lignes selectionnées
      const ligneSelected: Array<StageInter> = event.api.getSelectedRows();

      if (ligneSelected.length > 0) {
        // Recherche si un autre stage a ete selectionne 
        const index: number = ligneSelected.findIndex((x: StageInter) => x.IdStage !== this.ModalLigne.IdStage);
        if (index > -1) {
          // Nouveau stage selectionne
          this.ModalLigne.IdStage = ligneSelected[index].IdStage;
        }
        else {
          // Premier stage selectionné
          this.ModalLigne.IdStage = ligneSelected[0].IdStage;
        }
        this.ModalLigne.StageState = StageState.OK;

        // Reservation du premier stage selectionné
        ligneSelected.forEach((stageInter: StageInter) => {
          if (this.ModalLigne.IdStage == stageInter.IdStage) {
            this.ModalLigne.ListResa.push(stageInter.IdResa);
          }
        });

        event.api.forEachLeafNode((node: RowNode) => {
          if (node.data.IdStage != this.ModalLigne.IdStage)
            node.setSelected(false);
        });
      } else {
        this.ModalLigne.IdStage = '0';
        this.ModalLigne.StageState = StageState.NOSTAGE;
      }
    }
  }

  private CheckStageInterState(): boolean {
    let result: boolean = false;
    if (this.Model.ModeTransform == ModeTransformation.CONVENTION) {
      if (this.Model.DataLigneDevis.LigneDevis.some((ligne: LigneDevisTransform) => { return ligne.Selected && (ligne.StageState == StageState.EXPIRED || ligne.StageState == StageState.NOSTAGE || ligne.StageState == StageState.NULL) })) {

        result = true;
        this.toast.showWarningToast("Pas de stage sélectionné pour la transformation de ce devis");
      }
    }
    return result;
  }



  public OnChangeTypeLigne(event: any, ligne: LigneDevisTransform) {
    ligne.IdStage = '0';
    if (ligne.CurrentTypeLigne == TypeLigneDevis.INTRA) {
      ligne.StageState = StageState.INTRA;
    } else if (ligne.CurrentTypeLigne == TypeLigneDevis.INTER) {
      ligne.StageState = StageState.NOSTAGE;
    } else if (ligne.CurrentTypeLigne == TypeLigneDevis.FRAIS) {
      ligne.StageState = StageState.FRAIS;
    }
  }


  public RecalculeMontantPrestation(bo: any) {
    switch (this.Model.ModeTransform) {
      case ModeTransformation.PRESTATION:
        if (bo.Title === 'Prestation') {
          this.http.getHttp<ActionCoTransformModel>(`${this.indParam.AppParams.apiUrl}api/ActionCO/Transform/RECALCULEPRESTATION/${this.Model.PersonneMorale.Id}|${bo.IdFils}/`).subscribe((result: ActionCoTransformModel) => {
            let idFils = bo.IdFils;
            this.GetBo('REL_BO_CSOC_BO_PRESTATION', this.Model.PersonneMorale.Id, idFils).subscribe((resultBo: BObjectModel) => {
              let bo: any = { Title: 'Prestation', Model: resultBo, IdFils: idFils }
              this.ListBo = [bo];
              this.Active = 1;
            });
          });
        }
        break;
      case ModeTransformation.CONVENTION:
        if (bo.Title === 'Convention') {
          this.http.getHttp<ActionCoTransformModel>(`${this.indParam.AppParams.apiUrl}api/ActionCO/Transform/RECALCULECONVENTION/${this.Model.PersonneMorale.Id}|${bo.IdFils}/`).subscribe(() => {
            let idFils = bo.IdFils;
            this.GetBo('REL_BO_CSOC_BO_CVT', this.Model.PersonneMorale.Id, idFils).subscribe((resultBo: BObjectModel) => {
              let bo: any = { Title: 'Convention', Model: resultBo, IdFils: idFils }
              this.ListBo = [bo];
              this.Active = 1;
            });
          });
        }
        break;
    }
  }

  private GetFinanceurByConvention(): void {
    this.http.getHttp<ActionCoTransformModel>(`${this.indParam.AppParams.apiUrl}api/ActionCO/Transform/GETFINANCEURBYCVT/${this.Model.DataLigneDevis.Convention.id}/`).subscribe((result: ActionCoTransformModel) => {
      if (!result.HasError) {
        this.Model.Financeur = result.Financeur;
      }
    });
  }

  private GetContactByConvention(value: QueovalItem | null = null): void {
    this.http.getHttp<ActionCoTransformModel>(`${this.indParam.AppParams.apiUrl}api/ActionCO/Transform/GETCNTBYCVT/${this.Model.DataLigneDevis.Convention.id}/`).subscribe((result: ActionCoTransformModel) => {
      if (!result.HasError) {

        result.ListContact.forEach((selected: ActionCoContact) => {
          if (value == null || !this.Model.ListContactPrincipal.some(resp => resp.id == value.Value)) {
            const contact: ActionCoContact | undefined = this.Model.ListContact.find(cnt => cnt.id == selected.id);
            if (contact) {
              contact.selected = true;
            } else {
              selected.selected = true;
              this.Model.ListContact.push(selected);
            }
          }
        });

        result.ListContactPrincipal.forEach((selected: ActionCoContact) => {
          const contact: ActionCoContact | undefined = this.Model.ListContactPrincipal.find(cnt => cnt.id == selected.id);
          if (contact) {
            contact.selected = true;
          } else {
            selected.selected = true;
            this.Model.ListContact.push(selected);
          }
        });
      }
    });
  }
}
